import { navigate } from './constants';
import VIEWS from '../Views';

export default function moveDate(action, _date, view) {
  let date = _date;
  switch (action) {
    case navigate.TODAY:
      date = new Date();
      break;
    case navigate.DATE:
      break;
    default:
      date = VIEWS[view].navigate(date, action);
  }

  return date;
}
